<div class="innerPagesBlock">
  <app-side-menu></app-side-menu>
  <div class="admin-panel">
    <!-- <app-banner-footer-pages [title]="title1"></app-banner-footer-pages> -->
    <!-- <app-banner-profile
      [image]="img1"
      [title]="title1"
      [customClasses]="class1"
    ></app-banner-profile> -->
    <!-- <app-main-heading [title]="title"></app-main-heading> -->
    <div class="business-category-page">
      <div class="innerpageContent mb-5">
        <div class="top-categeryHead">
          <div class="categeryHead-text">
            <h1 [innerHTML]="title"></h1>
          </div>
          <div class="btnGrpp">
            <button class="gredientOutLineBtn" (click)="toggleModel()">
              <div class="btnContent">
                + New Category
                <!-- <img src="./assets/images/edit-line.svg" alt="edit" /> -->
              </div>
            </button>
          </div>
        </div>

        <div class="admin-table">
          <table class="adminPanel-table">
            <tr>
              <th colspan="2">Business Category</th>
              <th>Category Thumbnail</th>
              <th>added Date</th>
              <th>ACTIONS</th>
            </tr>
            <tr>
              <td class="serielNo">1</td>
              <td class="align-left">Category one</td>
              <td class="business-thumbnail">
                <img src="../../../assets/images/add-file.svg" alt="" />
              </td>

              <td>24/10/2023</td>
              <td>
                <div class="actions">
                  <div class="action-edit">
                    <img src="../../../assets/images/edit-icon.svg" alt="" />
                  </div>
                  <div class="action-del">
                    <img src="../../../assets/images/trash-icon.svg" alt="" />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="serielNo">1</td>
              <td class="align-left">Category one</td>
              <td class="business-thumbnail">
                <img src="../../../assets/images/add-file.svg" alt="" />
              </td>

              <td>24/10/2023</td>
              <td>
                <div class="actions">
                  <div class="action-edit">
                    <img src="../../../assets/images/edit-icon.svg" alt="" />
                  </div>
                  <div class="action-del">
                    <img src="../../../assets/images/trash-icon.svg" alt="" />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="serielNo">1</td>
              <td class="align-left">Category one</td>
              <td class="business-thumbnail">
                <img src="../../../assets/images/add-file.svg" alt="" />
              </td>

              <td>24/10/2023</td>
              <td>
                <div class="actions">
                  <div class="action-edit">
                    <img src="../../../assets/images/edit-icon.svg" alt="" />
                  </div>
                  <div class="action-del">
                    <img src="../../../assets/images/trash-icon.svg" alt="" />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="serielNo">1</td>
              <td class="align-left">Category one</td>
              <td class="business-thumbnail">
                <img src="../../../assets/images/add-file.svg" alt="" />
              </td>

              <td>24/10/2023</td>
              <td>
                <div class="actions">
                  <div class="action-edit">
                    <img src="../../../assets/images/edit-icon.svg" alt="" />
                  </div>
                  <div class="action-del">
                    <img src="../../../assets/images/trash-icon.svg" alt="" />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="serielNo">1</td>
              <td class="align-left">Category one</td>
              <td class="business-thumbnail">
                <img src="../../../assets/images/add-file.svg" alt="" />
              </td>

              <td>24/10/2023</td>
              <td>
                <div class="actions">
                  <div class="action-edit">
                    <img src="../../../assets/images/edit-icon.svg" alt="" />
                  </div>
                  <div class="action-del">
                    <img src="../../../assets/images/trash-icon.svg" alt="" />
                  </div>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="innerpageContent mb-5">
        <div class="top-categeryHead">
          <div class="categeryHead-text">
            <h1 [innerHTML]="title2"></h1>
          </div>
          <div class="btnGrpp">
            <button class="gredientOutLineBtn" (click)="toggleModelB()">
              <div class="btnContent">
                + New Sub Category
                <!-- <img src="./assets/images/edit-line.svg" alt="edit" /> -->
              </div>
            </button>
          </div>
        </div>

        <div class="admin-table">
          <table class="adminPanel-table">
            <tr>
              <th colspan="2">Business Category</th>
              <th>Sub Category</th>
              <th>Business Type</th>
              <th>added Date</th>
              <th>ACTIONS</th>
            </tr>
            <tr>
              <td class="serielNo">1</td>
              <td class="align-left">Category one</td>
              <td>Sub Category 1</td>
              <td>Product</td>
              <td>24/10/2023</td>
              <td>
                <div class="actions">
                  <div class="action-edit">
                    <img src="../../../assets/images/edit-icon.svg" alt="" />
                  </div>
                  <div class="action-del">
                    <img src="../../../assets/images/trash-icon.svg" alt="" />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="serielNo">1</td>
              <td class="align-left">Category one</td>
              <td>Sub Category 1</td>
              <td>Product</td>
              <td>24/10/2023</td>
              <td>
                <div class="actions">
                  <div class="action-edit">
                    <img src="../../../assets/images/edit-icon.svg" alt="" />
                  </div>
                  <div class="action-del">
                    <img src="../../../assets/images/trash-icon.svg" alt="" />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="serielNo">1</td>
              <td class="align-left">Category one</td>
              <td>Sub Category 1</td>
              <td>Product</td>
              <td>24/10/2023</td>
              <td>
                <div class="actions">
                  <div class="action-edit">
                    <img src="../../../assets/images/edit-icon.svg" alt="" />
                  </div>
                  <div class="action-del">
                    <img src="../../../assets/images/trash-icon.svg" alt="" />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="serielNo">1</td>
              <td class="align-left">Category one</td>
              <td>Sub Category 1</td>
              <td>Product</td>
              <td>24/10/2023</td>
              <td>
                <div class="actions">
                  <div class="action-edit">
                    <img src="../../../assets/images/edit-icon.svg" alt="" />
                  </div>
                  <div class="action-del">
                    <img src="../../../assets/images/trash-icon.svg" alt="" />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="serielNo">1</td>
              <td class="align-left">Category one</td>
              <td>Sub Category 1</td>
              <td>Product</td>
              <td>24/10/2023</td>
              <td>
                <div class="actions">
                  <div class="action-edit">
                    <img src="../../../assets/images/edit-icon.svg" alt="" />
                  </div>
                  <div class="action-del">
                    <img src="../../../assets/images/trash-icon.svg" alt="" />
                  </div>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="innerpageContent mb-5">
        <div class="top-categeryHead">
          <div class="categeryHead-text">
            <h1 [innerHTML]="title3"></h1>
          </div>
          <div class="btnGrpp">
            <button class="gredientOutLineBtn" (click)="toggleModelC()">
              <div class="btnContent">
                + New Entity
                <!-- <img src="./assets/images/edit-line.svg" alt="edit" /> -->
              </div>
            </button>
          </div>
        </div>

        <div class="admin-table">
          <table class="adminPanel-table">
            <tr>
              <th colspan="2">Entity type</th>
              <th>Ownership type</th>
              <th>added Date</th>
              <th>ACTIONS</th>
            </tr>
            <tr>
              <td class="serielNo">1</td>
              <td class="align-left">Category one</td>
              <td>Proprietor</td>
              <td>24/10/2023</td>
              <td>
                <div class="actions">
                  <div class="action-edit">
                    <img src="../../../assets/images/edit-icon.svg" alt="" />
                  </div>
                  <div class="action-del">
                    <img src="../../../assets/images/trash-icon.svg" alt="" />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="serielNo">1</td>
              <td class="align-left">Category one</td>
              <td>Proprietor</td>
              <td>24/10/2023</td>
              <td>
                <div class="actions">
                  <div class="action-edit">
                    <img src="../../../assets/images/edit-icon.svg" alt="" />
                  </div>
                  <div class="action-del">
                    <img src="../../../assets/images/trash-icon.svg" alt="" />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="serielNo">1</td>
              <td class="align-left">Category one</td>
              <td>Proprietor</td>
              <td>24/10/2023</td>
              <td>
                <div class="actions">
                  <div class="action-edit">
                    <img src="../../../assets/images/edit-icon.svg" alt="" />
                  </div>
                  <div class="action-del">
                    <img src="../../../assets/images/trash-icon.svg" alt="" />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="serielNo">1</td>
              <td class="align-left">Category one</td>
              <td>Proprietor</td>
              <td>24/10/2023</td>
              <td>
                <div class="actions">
                  <div class="action-edit">
                    <img src="../../../assets/images/edit-icon.svg" alt="" />
                  </div>
                  <div class="action-del">
                    <img src="../../../assets/images/trash-icon.svg" alt="" />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="serielNo">1</td>
              <td class="align-left">Category one</td>
              <td>Proprietor</td>
              <td>24/10/2023</td>
              <td>
                <div class="actions">
                  <div class="action-edit">
                    <img src="../../../assets/images/edit-icon.svg" alt="" />
                  </div>
                  <div class="action-del">
                    <img src="../../../assets/images/trash-icon.svg" alt="" />
                  </div>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="innerpageContent mb-5">
        <div class="top-categeryHead">
          <div class="categeryHead-text">
            <h1 [innerHTML]="title4"></h1>
          </div>
          <div class="btnGrpp">
            <button class="gredientOutLineBtn" (click)="toggleModelD()">
              <div class="btnContent">
                + New Documenty
                <!-- <img src="./assets/images/edit-line.svg" alt="edit" /> -->
              </div>
            </button>
          </div>
        </div>

        <table class="adminPanel-table">
          <tr>
            <th colspan="2">Document Name</th>
            <th>Expiry Date</th>
            <th>added Date</th>
            <th>ACTIONS</th>
          </tr>
          <tr>
            <td class="serielNo">1</td>
            <td class="align-left">Category one</td>
            <td>yes</td>
            <td>24/10/2023</td>
            <td>
              <div class="actions">
                <div class="action-edit">
                  <img src="../../../assets/images/edit-icon.svg" alt="" />
                </div>
                <div class="action-del">
                  <img src="../../../assets/images/trash-icon.svg" alt="" />
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="serielNo">1</td>
            <td class="align-left">Category one</td>
            <td>yes</td>
            <td>24/10/2023</td>
            <td>
              <div class="actions">
                <div class="action-edit">
                  <img src="../../../assets/images/edit-icon.svg" alt="" />
                </div>
                <div class="action-del">
                  <img src="../../../assets/images/trash-icon.svg" alt="" />
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="serielNo">1</td>
            <td class="align-left">Category one</td>
            <td>yes</td>
            <td>24/10/2023</td>
            <td>
              <div class="actions">
                <div class="action-edit">
                  <img src="../../../assets/images/edit-icon.svg" alt="" />
                </div>
                <div class="action-del">
                  <img src="../../../assets/images/trash-icon.svg" alt="" />
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="serielNo">1</td>
            <td class="align-left">Category one</td>
            <td>yes</td>
            <td>24/10/2023</td>
            <td>
              <div class="actions">
                <div class="action-edit">
                  <img src="../../../assets/images/edit-icon.svg" alt="" />
                </div>
                <div class="action-del">
                  <img src="../../../assets/images/trash-icon.svg" alt="" />
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="serielNo">1</td>
            <td class="align-left">Category one</td>
            <td>yes</td>
            <td>24/10/2023</td>
            <td>
              <div class="actions">
                <div class="action-edit">
                  <img src="../../../assets/images/edit-icon.svg" alt="" />
                </div>
                <div class="action-del">
                  <img src="../../../assets/images/trash-icon.svg" alt="" />
                </div>
              </div>
            </td>
          </tr>
        </table>
      </div>
      <div class="innerpageContent mb-5">
        <div class="top-categeryHead">
          <div class="categeryHead-text">
            <h1 [innerHTML]="title5"></h1>
          </div>
          <div class="btnGrpp">
            <button class="gredientOutLineBtn" (click)="toggleModelE()">
              <div class="btnContent">
                + New Mapping Category
                <!-- <img src="./assets/images/edit-line.svg" alt="edit" /> -->
              </div>
            </button>
          </div>
        </div>

        <div class="admin-table">
          <table class="adminPanel-table">
            <tr>
              <th colspan="2">Business Category</th>
              <th>Sub Category</th>
              <th>Business Type</th>
              <th>View List</th>
              <th>added Date</th>
              <th>ACTIONS</th>
            </tr>
            <tr>
              <td class="serielNo">1</td>
              <td class="align-left">Category one</td>
              <td>Sub Category 1</td>
              <td>Product</td>
              <td>
                <div class="action-edit">
                  <img src="../../../assets/images/eye-line.svg" alt="" />
                </div>
              </td>
              <td>24/10/2023</td>
              <td>
                <div class="actions">
                  <div class="action-edit">
                    <img src="../../../assets/images/edit-icon.svg" alt="" />
                  </div>
                  <div class="action-del">
                    <img src="../../../assets/images/trash-icon.svg" alt="" />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="serielNo">1</td>
              <td class="align-left">Category one</td>
              <td>Sub Category 1</td>
              <td>Product</td>
              <td>
                <div class="action-edit">
                  <img src="../../../assets/images/eye-line.svg" alt="" />
                </div>
              </td>
              <td>24/10/2023</td>
              <td>
                <div class="actions">
                  <div class="action-edit">
                    <img src="../../../assets/images/edit-icon.svg" alt="" />
                  </div>
                  <div class="action-del">
                    <img src="../../../assets/images/trash-icon.svg" alt="" />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="serielNo">1</td>
              <td class="align-left">Category one</td>
              <td>Sub Category 1</td>
              <td>Product</td>
              <td>
                <div class="action-edit">
                  <img src="../../../assets/images/eye-line.svg" alt="" />
                </div>
              </td>
              <td>24/10/2023</td>
              <td>
                <div class="actions">
                  <div class="action-edit">
                    <img src="../../../assets/images/edit-icon.svg" alt="" />
                  </div>
                  <div class="action-del">
                    <img src="../../../assets/images/trash-icon.svg" alt="" />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="serielNo">1</td>
              <td class="align-left">Category one</td>
              <td>Sub Category 1</td>
              <td>Product</td>
              <td>
                <div class="action-edit">
                  <img src="../../../assets/images/eye-line.svg" alt="" />
                </div>
              </td>
              <td>24/10/2023</td>
              <td>
                <div class="actions">
                  <div class="action-edit">
                    <img src="../../../assets/images/edit-icon.svg" alt="" />
                  </div>
                  <div class="action-del">
                    <img src="../../../assets/images/trash-icon.svg" alt="" />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="serielNo">1</td>
              <td class="align-left">Category one</td>
              <td>Sub Category 1</td>
              <td>Product</td>
              <td>
                <div class="action-edit">
                  <img src="../../../assets/images/eye-line.svg" alt="" />
                </div>
              </td>
              <td>24/10/2023</td>
              <td>
                <div class="actions">
                  <div class="action-edit">
                    <img src="../../../assets/images/edit-icon.svg" alt="" />
                  </div>
                  <div class="action-del">
                    <img src="../../../assets/images/trash-icon.svg" alt="" />
                  </div>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
<c-modal
  id="productDetails"
  [visible]="showAddModel"
  backdrop="static"
  class="appModel"
  alignment="center"
  size="lg"
>
  <div class="modelContentBox py-3 px-4">
    <div class="modelheader mb-3">
      <button
        (click)="toggleModel()"
        cButtonClose
        class="modelClose productModelCloseBtn"
      >
        <img src="../../../assets/images/c-remove-btn.svg" alt="" />
      </button>
    </div>
    <div class="modelBody">
      <!-- <div class="top-categeryHead">
        <div class="categeryHead-text">
          <h1 [innerHTML]="title6"></h1>
        </div>
      </div> -->
      <app-main-heading [title]="title6"></app-main-heading>

      <div class="add-category-contents">
        <form>
          <div class="innerpageContent">
            <div class="add-cat-thumb">
              <div class="row">
                <div class="col-lg-12">
                  <div class="inputGroup">
                    <input
                      onkeydown="return /[a-z ]/i.test(event.key)"
                      type="text"
                      formControlName="Article-title"
                      class="inputBox"
                      id="businessCategory"
                      placeholder=""
                    />
                    <label for="businessCategory" class="inputLabel"
                      >Business Category</label
                    >
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="inputGroup">
                    <input
                      onkeydown="return /[a-z ]/i.test(event.key)"
                      type="text"
                      formControlName="Article-title"
                      class="inputBox"
                      id="categoryDescription"
                      placeholder=""
                    />
                    <label for="categoryDescription" class="inputLabel"
                      >Category Description</label
                    >
                  </div>
                </div>
              </div>
              <div class="thumbnail-box">
                <div class="thumbnail-text">Upload Thumbnail</div>
                <div class="add-thumbnail">
                  <img src="../../../assets/images/add-file.svg" alt="" />
                </div>
              </div>
            </div>
          </div>
          <div class="text-center">
            <div class="btnbx mt-5">
              <button type="button" class="btnThemeOutline blue me-3">
                Cancel
              </button>
              <button class="btnTheme red" type="submit">Save</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</c-modal>
<c-modal
  id="productDetails"
  [visible]="showAddModelB"
  backdrop="static"
  class="appModel"
  alignment="center"
  size="lg"
>
  <div class="modelContentBox py-3 px-4">
    <div class="modelheader mb-3">
      <button
        (click)="toggleModelB()"
        cButtonClose
        class="modelClose productModelCloseBtn"
      >
        <img src="../../../assets/images/c-remove-btn.svg" alt="" />
      </button>
    </div>
    <div class="modelBody">
      <!-- <div class="top-categeryHead">
        <div class="categeryHead-text">
          <h1 [innerHTML]="title7"></h1>
        </div>
      </div> -->
      <app-main-heading [title]="title7"></app-main-heading>

      <div class="add-category-contents">
        <form>
          <div class="innerpageContent">
            <div class="row g-2 g-lg-4">
              <div class="col-lg-12">
                <div class="inputGroup">
                  <input
                    onkeydown="return /[a-z ]/i.test(event.key)"
                    type="text"
                    formControlName="Article-title"
                    class="inputBox"
                    id="subCategory"
                    placeholder=""
                  />
                  <label for="subCategory" class="inputLabel"
                    >Sub Category</label
                  >
                </div>
              </div>

              <div class="col-lg-6 col-6">
                <div class="inputGroup mt-2">
                  <mat-form-field
                    class="w-100 mat-input-group"
                    appearance="outline"
                  >
                    <mat-label class="matLabel">Select Category</mat-label>
                    <mat-select>
                      <mat-option>test1</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-6 col-6">
                <div class="inputGroup mt-2">
                  <mat-form-field
                    class="w-100 mat-input-group"
                    appearance="outline"
                  >
                    <mat-label class="matLabel">Select Business Type</mat-label>
                    <mat-select formControlName="eduQualification">
                      <mat-option>test1</mat-option>
                      <mat-option>test1</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
          <div class="text-center">
            <div class="btnbx mt-5">
              <button type="button" class="btnThemeOutline blue me-3">
                Cancel
              </button>
              <button class="btnTheme red" type="submit">Save</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</c-modal>
<c-modal
  id="productDetails"
  [visible]="showAddModelC"
  backdrop="static"
  class="appModel"
  alignment="center"
  size="lg"
>
  <div class="modelContentBox py-3 px-4">
    <div class="modelheader mb-3">
      <button
        (click)="toggleModelC()"
        cButtonClose
        class="modelClose productModelCloseBtn"
      >
        <img src="../../../assets/images/c-remove-btn.svg" alt="" />
      </button>
    </div>
    <div class="modelBody">
      <!-- <div class="top-categeryHead">
        <div class="categeryHead-text">
          <h1 [innerHTML]="title8"></h1>
        </div>
      </div> -->
      <app-main-heading [title]="title8"></app-main-heading>

      <div class="add-category-contents">
        <form>
          <div class="innerpageContent">
            <div class="row g-2 g-lg-4">
              <div class="col-lg-8 col-8">
                <div class="inputGroup">
                  <input
                    onkeydown="return /[a-z ]/i.test(event.key)"
                    type="text"
                    formControlName="Article-title"
                    class="inputBox"
                    id="documentName"
                    placeholder=""
                  />
                  <label for="documentName" class="inputLabel"
                    >Entity type</label
                  >
                </div>
              </div>
              <!-- <div class="col-lg-6 col-6">
                <div class="inputGroup mt-2">
                  <mat-form-field
                    class="w-100 mat-input-group"
                    appearance="outline"
                  >
                    <mat-label class="matLabel">Select Category</mat-label>
                    <mat-select formControlName="selectCategory">
                      <mat-option>test1</mat-option>
                      <mat-option>test1</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div> -->
              <div class="col-lg-4 col-4">
                <div class="inputGroup">
                  <mat-form-field
                    class="w-100 mat-input-group"
                    appearance="outline"
                  >
                    <mat-label class="matLabel">Ownership type</mat-label>
                    <mat-select formControlName="eduQualification">
                      <mat-option>test1</mat-option>
                      <mat-option>test1</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
          <div class="text-center">
            <div class="btnbx mt-5">
              <button type="button" class="btnThemeOutline blue me-3">
                Cancel
              </button>
              <button class="btnTheme red" type="submit">Save</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</c-modal>
<c-modal
  id="productDetails"
  [visible]="showAddModelD"
  backdrop="static"
  class="appModel"
  alignment="center"
  size="lg"
>
  <div class="modelContentBox py-3 px-4">
    <div class="modelheader mb-3">
      <button
        (click)="toggleModelD()"
        cButtonClose
        class="modelClose productModelCloseBtn"
      >
        <img src="../../../assets/images/c-remove-btn.svg" alt="" />
      </button>
    </div>
    <div class="modelBody">
      <!-- <div class="top-categeryHead">
        <div class="categeryHead-text">
          <h1 [innerHTML]="title10"></h1>
        </div>
      </div> -->
      <app-main-heading [title]="title10"></app-main-heading>

      <div class="add-category-contents">
        <form>
          <div class="innerpageContent">
            <div class="row g-2 g-lg-4">
              <div class="col-lg-8 col-8">
                <div class="inputGroup">
                  <input
                    onkeydown="return /[a-z ]/i.test(event.key)"
                    type="text"
                    formControlName="Article-title"
                    class="inputBox"
                    id="documentName"
                    placeholder=""
                  />
                  <label for="documentName" class="inputLabel"
                    >Document Name</label
                  >
                </div>
              </div>
              <div class="col-lg-4 col-4">
                <div class="inputGroup">
                  <input
                    onkeydown="return /[a-z ]/i.test(event.key)"
                    type="text"
                    formControlName="Article-title"
                    class="inputBox"
                    id="expiryDate"
                    placeholder=""
                  />
                  <label for="expiryDate" class="inputLabel">Expiry Date</label>
                </div>
              </div>
            </div>
          </div>
          <div class="text-center">
            <div class="btnbx mt-5">
              <button type="button" class="btnThemeOutline blue me-3">
                Cancel
              </button>
              <button class="btnTheme red" type="submit">Save</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</c-modal>
<c-modal
  id="productDetails"
  [visible]="showAddModelE"
  backdrop="static"
  class="appModel"
  alignment="center"
  size="lg"
>
  <div class="modelContentBox py-3 px-4">
    <div class="modelheader mb-3">
      <button
        (click)="toggleModelE()"
        cButtonClose
        class="modelClose productModelCloseBtn"
      >
        <img src="../../../assets/images/c-remove-btn.svg" alt="" />
      </button>
    </div>
    <div class="modelBody">
      <!-- <div class="top-categeryHead">
        <div class="categeryHead-text">
          <h1 [innerHTML]="title7"></h1>
        </div>
      </div> -->
      <app-main-heading [title]="title7"></app-main-heading>

      <div class="add-category-contents">
        <form>
          <div class="innerpageContent">
            <div class="row g-2 g-lg-4">
              <div class="col-lg-6 col-6">
                <div class="inputGroup mt-2">
                  <mat-form-field
                    class="w-100 mat-input-group"
                    appearance="outline"
                  >
                    <mat-label class="matLabel">Select Category</mat-label>
                    <mat-select>
                      <mat-option>test1</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-6 col-6">
                <div class="inputGroup mt-2">
                  <mat-form-field
                    class="w-100 mat-input-group"
                    appearance="outline"
                  >
                    <mat-label class="matLabel">Select Sub Category</mat-label>
                    <mat-select>
                      <mat-option>test1</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-6 col-6">
                <div class="inputGroup mt-2">
                  <mat-form-field
                    class="w-100 mat-input-group"
                    appearance="outline"
                  >
                    <mat-label class="matLabel">Select Entity Type</mat-label>
                    <mat-select formControlName="eduQualification">
                      <mat-option>test1</mat-option>
                      <mat-option>test1</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
          <div class="document-type-title">Select Document Type</div>
          <div class="document-type-box">
            <div class="row">
              <div class="col-lg-4">
                <div class="document-check">
                  <label for="gst">GST Certificate</label>
                  <input type="checkbox" id="gst" />
                </div>
              </div>
              <div class="col-lg-4">
                <div class="document-check">
                  <label for="pan">Pan Card</label>
                  <input type="checkbox" id="pan" />
                </div>
              </div>
              <div class="col-lg-4">
                <div class="document-check">
                  <label for="businessDocument">Business Document</label>
                  <input type="checkbox" id="businessDocument" />
                </div>
              </div>
            </div>
          </div>
          <div class="document-type-box">
            <div class="row">
              <div class="col-lg-4">
                <div class="document-check">
                  <label for="businessDocuments">Business Document </label>
                  <input type="checkbox" id="businessDocuments" />
                </div>
              </div>
              <div class="col-lg-4">
                <div class="document-check">
                  <label for="businessDocuments2">Business Document </label>
                  <input type="checkbox" id="businessDocuments2" />
                </div>
              </div>
              <div class="col-lg-4">
                <div class="document-check">
                  <label for="businessDocuments3">Business Document </label>
                  <input type="checkbox" id="businessDocuments3" />
                </div>
              </div>
            </div>
          </div>
          <div class="text-center">
            <div class="btnbx mt-5">
              <button type="button" class="btnThemeOutline blue me-3">
                Cancel
              </button>
              <button class="btnTheme red" type="submit">Save</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</c-modal>
